export const captureRecoveryMessages = {
  'zh-CN': {
    screenSteps: '点击下方按钮，在浏览器共享弹窗中选择「整个屏幕」，选中游戏所在的屏幕，再点击「共享」。',
    tryScreen: '尝试采集整个屏幕',
    retryScreen: '重试整屏采集',
    screenFailed: '整屏采集也未能启动',
    attemptFailed: '这次采集仍未启动',
    retryHint: '请先完全退出浏览器后重开，或改用最新版 Edge / Chrome，再尝试采集。',
    screenHint: '请让游戏尽量铺满所选屏幕，并保持可见，避免最小化或被其他窗口遮挡。连接后检查等级和经验；识别不准确时，请调整识别区域。',
    more: '更多排查方法',
    windowMode: '将游戏切换为窗口化或无边框模式，并保持游戏画面可见。',
    browser: '完全退出浏览器后重开，或改用最新版 Microsoft Edge / Google Chrome。',
    driver: '仍无法连接时，重启电脑并更新显卡驱动和 Windows。若有录屏、直播或远程桌面正在运行，也可关闭后重试。',
    compare: '可以选择记事本等普通窗口作对照：只有游戏失败时，优先检查游戏显示模式；所有来源都失败时，优先检查浏览器和系统。',
    copy: '复制诊断信息',
    copied: '诊断信息已复制',
    copyFailed: '自动复制失败，请手动选择并复制下方诊断信息。',
    diagnostic: '采集诊断信息',
  },
  en: {
    screenSteps: 'Click the button below. In the browser sharing dialog, choose “Entire screen”, select the screen containing the game, then click “Share”.',
    tryScreen: 'Try capturing the entire screen',
    retryScreen: 'Retry screen capture',
    screenFailed: 'Entire-screen capture could not start either',
    attemptFailed: 'This capture attempt still could not start',
    retryHint: 'Fully quit and reopen the browser, or try the latest Edge / Chrome before capturing again.',
    screenHint: 'Let the game fill as much of the selected screen as possible and keep it visible, without minimizing it or covering it with other windows. Check the level and EXP after connecting; adjust the recognition regions if needed.',
    more: 'More troubleshooting steps',
    windowMode: 'Switch the game to windowed or borderless mode and keep the game visible.',
    browser: 'Fully quit and reopen the browser, or try the latest Microsoft Edge / Google Chrome.',
    driver: 'If capture still fails, restart the computer and update the graphics driver and Windows. If recording, streaming, or remote-desktop tools are running, also try closing them.',
    compare: 'Try a regular window such as Notepad: if only the game fails, check its display mode first; if every source fails, check the browser and system first.',
    copy: 'Copy diagnostics',
    copied: 'Diagnostics copied',
    copyFailed: 'Automatic copying failed. Select and copy the diagnostics below manually.',
    diagnostic: 'Capture diagnostics',
  },
} as const
